var map = {
	"./de/video-btn.png": "hF51",
	"./en/video-btn.png": "AdWB",
	"./es/video-btn.png": "7C87",
	"./fr/video-btn.png": "prF8",
	"./ja/video-btn.png": "vRgr",
	"./ko/video-btn.png": "MGq6",
	"./pt/video-btn.png": "RT/z",
	"./ru/video-btn.png": "UuaS",
	"./tc/video-btn.png": "52Pq",
	"./th/video-btn.png": "jpn/"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Jnox";